// extracted by mini-css-extract-plugin
module.exports = {"wrap":"TextBox_wrap__Dlwtd","visibleWrap":"TextBox_visibleWrap__3nWjZ","invisibleWrap":"TextBox_invisibleWrap__R6nvw"};